var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-wrapper"},[_c('promo-section'),_c('show'),_c('about-section'),_c('design-section'),_c('preview-section'),_c('news-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }